import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function TermsPage() {
    const navigate = useNavigate()
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&display=swap');

        * { box-sizing: border-box; margin: 0; padding: 0; }

        .page {
          background: linear-gradient(160deg, #253246 0%, #1e2738 100%);
          min-height: 100vh;
          font-family: 'DM Sans', sans-serif;
          color: #ffffff;
          padding: 60px 24px 100px;
        }

        .container {
          max-width: 680px;
          margin: 0 auto;
        }

        .header {
          border-bottom: 1px solid rgba(255,255,255,0.15);
          padding-bottom: 32px;
          margin-bottom: 48px;
        }

        .brand {
          font-size: 13px;
          font-weight: 500;
          letter-spacing: 3px;
          text-transform: uppercase;
          color: rgba(255,255,255,0.4);
          margin-bottom: 16px;
        }

        .main-title {
          font-size: clamp(32px, 6vw, 52px);
          font-weight: 700;
          color: #ffffff;
          line-height: 1.1;
          margin-bottom: 8px;
        }

        .updated {
          font-size: 12px;
          font-weight: 400;
          color: rgba(255,255,255,0.35);
          letter-spacing: 1px;
        }

        .notice {
          border-bottom: 1px solid rgba(255,255,255,0.1);
          padding-bottom: 40px;
          margin-bottom: 40px;
        }

        .notice p {
          font-size: 14px;
          line-height: 1.85;
          color: rgba(255,255,255,0.55);
          font-weight: 400;
        }

        .section {
          border-bottom: 1px solid rgba(255,255,255,0.1);
          padding-bottom: 40px;
          margin-bottom: 40px;
        }

        .section:last-of-type {
          border-bottom: none;
        }

        .section-label {
          font-size: 11px;
          font-weight: 600;
          letter-spacing: 3px;
          text-transform: uppercase;
          color: rgba(255,255,255,0.3);
          margin-bottom: 10px;
        }

        .section-title {
          font-size: clamp(18px, 3vw, 22px);
          font-weight: 700;
          color: #ffffff;
          margin-bottom: 20px;
          line-height: 1.3;
        }

        .section p {
          font-size: 14px;
          line-height: 1.9;
          color: rgba(255,255,255,0.55);
          font-weight: 400;
          margin-bottom: 14px;
        }

        .section p:last-child { margin-bottom: 0; }

        .sub-label {
          font-size: 11px;
          font-weight: 600;
          letter-spacing: 2px;
          text-transform: uppercase;
          color: rgba(255,255,255,0.3);
          margin: 24px 0 8px;
        }

        .pricing-table {
          width: 100%;
          border-collapse: collapse;
          margin-top: 16px;
        }

        .pricing-table th {
          font-size: 11px;
          font-weight: 600;
          letter-spacing: 2px;
          text-transform: uppercase;
          color: rgba(255,255,255,0.3);
          text-align: left;
          padding: 10px 0;
          border-bottom: 1px solid rgba(255,255,255,0.1);
        }

        .pricing-table td {
          font-size: 14px;
          font-weight: 400;
          color: rgba(255,255,255,0.55);
          padding: 14px 0;
          border-bottom: 1px solid rgba(255,255,255,0.06);
        }

        .pricing-table td:first-child {
          font-weight: 600;
          color: rgba(255,255,255,0.8);
        }

        .pricing-table tr:last-child td { border-bottom: none; }

        .list-item {
          display: flex;
          gap: 16px;
          margin-bottom: 16px;
          align-items: flex-start;
        }

        .list-num {
          font-size: 11px;
          font-weight: 600;
          color: rgba(255,255,255,0.25);
          margin-top: 3px;
          flex-shrink: 0;
          min-width: 22px;
        }

        .list-text {
          font-size: 14px;
          line-height: 1.9;
          color: rgba(255,255,255,0.55);
        }

        .contact-number {
          font-size: 42px;
          font-weight: 700;
          color: #ffffff;
          margin-top: 10px;
          letter-spacing: 2px;
        }

        .footer {
          padding-top: 40px;
          border-top: 1px solid rgba(255,255,255,0.08);
        }

        .footer p {
          font-size: 12px;
          color: rgba(255,255,255,0.25);
          font-weight: 400;
        }
      `}</style>

      <div className="page">
        <div className="container">
      <button className="flex items-center gap-1 text-white/60 hover:text-white border border-white/20 hover:border-white/40 transition-all text-base font-medium px-4 py-2 rounded-lg my-5"
      onClick={()=>{
        if (window.history.length > 1) {
          navigate(-1);
        } else {
          navigate('/terms');
        }
      }}>
      <ChevronLeft size={20} />
      Back
    </button>
          <div className="header">
            {/* <p className="brand">Econet Private Ltd</p> */}

            <img src="YoGamesXR.png" alt="" className=" w-[40vw] md:w-[20vw] px-1 py-3"/>
            <h1 className="main-title">Terms &amp; Conditions</h1>
            <p className="updated">YoGamezXR — Amended 01 February 2026</p>
          </div>

          <div className="notice">
            <p>
              These Terms and Conditions contain assumptions of risk and liability by you and limit and exclude liabilities, obligations and legal responsibilities which Econet Private Ltd will have towards you. They also limit and exclude your rights and remedies against Econet and place various risks, liabilities, obligations and legal responsibilities on you. Please read these Terms carefully. Participation in this offer constitutes your agreement to comply.
            </p>
          </div>

          <div className="section">
            {/* <p className="section-label">Section 01</p> */}
            <h2 className="section-title">Introduction</h2>
            <p>YoGamezXR is a portal of multiple skill-based, multiple level, and highly engaging web (HTML5) games in which subscribed users can play the games for unlimited times. Users can play any game of their choice in the portal, and the scores from any game are aggregated onto a common leaderboard which will be the basis for awarding prizes.</p>
            <p>The service is available exclusively to Econet subscribers who constitute natural persons ("the Users"). The Service is subscription-based.</p>
          </div>

          <div className="section">
            {/* <p className="section-label">Section 02</p> */}
            <h2 className="section-title">Duration</h2>
            <p>The Service is available from 01 March 2026 until such a time that Econet in their sole and absolute discretion elect to discontinue the Service.</p>
          </div>

          <div className="section">
            {/* <p className="section-label">Section 03</p> */}
            <h2 className="section-title">Who Is Eligible?</h2>
            <p>The Service is available to all ECONET prepaid subscribers who are natural persons with a valid ECONET mobile number ("the Users"). Only Users using SIM cards may participate in the Service.</p>
            <p>Should it be established that multiple SIM cards are being used, the User is automatically excluded from eligibility of any Prizes and may be reported to the relevant authorities should such usage result in any unlawful conduct.</p>
          </div>

          <div className="section">
            {/* <p className="section-label">Section 04</p> */}
            <h2 className="section-title">Subscription Methods</h2>
            <p>Users must subscribe to the Service using one of the following methods:</p>

            <p className="sub-label">Via USSD</p>
            <p>Dial *773# and go through the double opt-in confirmation steps. Upon successful subscription, you will receive a notification message along with the link to the game portal.</p>

            <p className="sub-label">Via Web</p>
            <p>Access the subscription page directly at https://yogamezxr.econet.co.zw</p>

            <p className="sub-label">Price Points</p>
            <table className="pricing-table">
              <thead>
                <tr>
                  <th>Pack</th>
                  <th>USD</th>
                  <th>ZWG</th>
                </tr>
              </thead>
              <tbody>
                <tr><td>Daily</td><td>$0.08</td><td>ZWG 3.00</td></tr>
                <tr><td>Weekly</td><td>$0.30</td><td>ZWG 15.00</td></tr>
                <tr><td>Monthly</td><td>$0.98</td><td>ZWG 45.00</td></tr>
              </tbody>
            </table>
          </div>

          <div className="section">
            {/* <p className="section-label">Section 05</p> */}
            <h2 className="section-title">Winner Determination &amp; Prizes</h2>
            <p>After subscribing, Users must play the game as many times as they wish. Rewards may be allocated from time to time in recognition of participant engagement and the achievement of certain milestones as determined at Econet's discretion.</p>
            <p>The nature, value, and timing of such rewards will be guided by campaign objectives and participation criteria. Qualification does not automatically guarantee a prize. All decisions made by Econet shall be final.</p>
            <p>In instances where multiple users share the same score, the user who first achieved the best score will be announced as the winner.</p>
            <p>Any erroneous SMS notifications indicating a participant has won shall not be deemed a valid confirmation of winning. Econet reserves the right to withdraw, amend, or nullify such communications and shall not be obligated to award the prize.</p>
          </div>

          <div className="section">
            {/* <p className="section-label">Section 06</p> */}
            <h2 className="section-title">Cancellation &amp; Unsubscribing</h2>
            <p>Users can unsubscribe at any time via USSD by dialling *773# and following the prompts. An SMS will confirm cancellation of the service.</p>
            <p>It is the User's obligation to ensure receipt of the confirmation SMS, as the Service may continue without it. Econet will not be liable for any loss incurred in such instances.</p>
            <p>Should a user unsubscribe before the end date of each competition period, they are not eligible to win the prize.</p>
          </div>

          <div className="section">
            {/* <p className="section-label">Section 07</p> */}
            <h2 className="section-title">Communication &amp; Marketing</h2>
            <p>By subscribing, you consent to receive communications from Econet for as long as your subscription remains active. Such communications may include service notifications, promotional messages, marketing content, competitions, and product updates via SMS or other approved channels.</p>
            <p>You may opt out of promotional communications where applicable, subject to the terms of the service.</p>
          </div>

          <div className="section">
            {/* <p className="section-label">Section 08</p> */}
            <h2 className="section-title">General</h2>
            <p>Econet is not responsible for service interruptions or network failures of any kind.</p>
            {[
              "Charges will be deducted from your prepaid mobile account balance in accordance with the subscription pack selected and will continue until the service is cancelled. You are responsible for ensuring your handset has messaging and mobile internet capability compatible with HTML5 games.",
              "The Service begins immediately after sign-up and will continue until the User requests cancellation and receives confirmation. As long as the service is not cancelled the User will be charged for it.",
              "Econet, their directors, affiliates, members, partners, employees, agents, consultants, suppliers, contractors, subsidiaries and sponsors assume no liability whatsoever for any direct or indirect loss or damage arising from participation in the Service. All participation shall be at the User's sole risk.",
              "All trademarks, copyright and intellectual property rights used or embodied in the Service shall remain vested solely with Econet. Users shall not attempt to decompile or reverse engineer any IP contained therein.",
              "Econet reserves the right to change these Terms and Conditions and any rules relating to its products and the Service, and to modify the Services at its discretion without notice.",
              "Econet reserves the right to modify, suspend or discontinue the Service at any time without notice and without liability to you or any third party.",
              "Econet reserves the right to vary the charges of the Service as deemed necessary, provided that the User shall obtain notification in respect thereof.",
              "Econet shall be entitled to terminate the Service of any User or withhold prizes if such User is in breach of these Terms or involved in any unlawful or fraudulent activity.",
              "A User that wins a prize agrees that they and their immediate family members are not eligible to win another prize within a period of 12 months from the date the prize was claimed, unless determined otherwise by Econet at their sole discretion.",
              "Econet is not liable for any technical failures affecting participation or prize redemption, including loss or misdirected entries, incorrect information submitted, or entries not received due to any failure of hardware, software, or other technical systems.",
            ].map((item, i) => (
              <div className="list-item" key={i}>
                <span className="list-num">{String(i + 1).padStart(2, "0")}</span>
                <span className="list-text">{item}</span>
              </div>
            ))}
          </div>

          <div className="section">
            {/* <p className="section-label">Section 09</p> */}
            <h2 className="section-title">Contact Us</h2>
            <p>For any queries or assistance, please contact our support centre.</p>
            <div className="contact-number">111</div>
          </div>

          <div className="footer">
            <p>© 2026 Econet Private Ltd · YoGamezXR · All Rights Reserved · Zimbabwe</p>
          </div>

        </div>
      </div>
    </>
  );
}